import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {WebsiteSearchFilterComponent} from './website-search-filter.component'
import {SharedModule} from '../shared/shared.module'
import {RouterModule} from '@angular/router'
import {BreadcrumbModule} from '../breadcrumb/breadcrumb.module'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    BreadcrumbModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    WebsiteSearchFilterComponent],
  exports: [
    WebsiteSearchFilterComponent
  ],
  providers: []
})
export class WebsiteSearchFilterModule {
}
